import { distributeAmount } from '@vita-mojo/bills-v2';

export function proportionallyDistribute<T, U>(
  input: Array<T>,
  getter: (elem?: T) => number,
  setter: (elem: T, res: number) => U,
  amount: number
): Array<U> {
  return distributeAmount(
    input.map(getter),
    amount
  ).map((res, i) => setter(input[i], res));
}
